import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    title: 'bg-white px-8 py-3 text-base active:bg-grey-90'
  }
} satisfies CMSConfig['megaMenuL3Mobile']
